import { Box, Button, Image, Text, useColorModeValue } from 'native-base'
import React, { useState, useRef, useEffect } from 'react'
import { widthPercentageToDP as wp } from 'react-native-responsive-screen'
import createStyles from './styles'
import Input from '../../../../components/Input'
import { useTheme } from '../../../../ThemeProvider.tsx'
import logo from '../../../img/logo_simples_mini.png'
import Api from '../../../../Api/Api'
import { useNavigation, useRoute } from '@react-navigation/native'
import StorageUtil from '../../../../Utils'
import Loader from '../../../../components/Loader'
import { StackNavigationProp } from '@react-navigation/stack'
import ModalConfirmacao from '../../../../components/ModalConfirmacao'
import {
  Image as RNImage,
  Pressable,
  ScrollView,
  StyleSheet,
  Text as RNText,
  TouchableOpacity,
  View
} from 'react-native'
import { CommonActions } from '@react-navigation/native'
import { Feather, FontAwesome } from '@expo/vector-icons'
import Campo from '../../../template/Etapas/Campo'
import { CORES, sombraCard } from '../../../template/Etapas/styles'
import {
  corComAlpha,
  corTextoSobre,
  gradienteHero
} from '../../../theme/cores'

const Login: React.FC = () => {
  const { primaryColor, getCodEmpresa, configEmpresa } = useTheme()
  const navigation = useNavigation<StackNavigationProp<any>>()
  const [cleaned, setCleaned] = useState('')
  const [textoModal, setTextoModal] = useState<String>('')
  const [cliente, setCliente] = useState<any>({})
  const [tipoOperacao, setTipoOperacao] = useState<number>(1)
  // 1 entrar normal,
  // 2 cadasrefLoadertrar,
  // 3 login com senha,
  // 4 alterar senha
  // 6 agendar sem cadastro -- não existe nessa tela, pois aparece o item para pessoa clicar.
  // 7 utiliza sistema apenas com telefone e nome - mas cadastra caso não exista
  const [nome, setNome] = useState<String>('')
  const [senha, setSenha] = useState<String>('')
  const [confirmaSenha, setConfirmaSenha] = useState<String>('')
  const [telefone, setTelefone] = useState<String>('')
  const [codigoRedenficao, setCodigoRedenficao] = useState<String>('')
  const [loader, setLoader] = useState<Boolean>(false)
  const [tipoOperacaoRedSenha, setTipoOperacaoRedSenha] = useState<number>(0) // 1 enviar codigo, 2 confirmar codigo
  const [dataNascimento, setDataNascimento] = useState<String>('')
  const [getConfigEmpresa, setConfigEmpresa] = useState<any>(
    JSON.parse(configEmpresa)
  )

  const styles = createStyles(getConfigEmpresa.coresPWA)

  const [clienteSimples, setClienteSimples] = useState<any>({})

  const [numeroInternacional, setNumeroInternacional] = useState<boolean>(false)

  // const backgroundColor = useColorModeValue('white', 'black');
  const backgroundColor = getConfigEmpresa.coresPWA.corFundo

  const refModal = useRef<any>(null)
  const refLoader = useRef<any>(null)
  const confirmationRef = useRef<any>(null)

  const route = useRoute()

  useEffect(() => {
    getClients()
    setTipoOperacaoRedSenha(0)
  }, [])

  async function getClients() {
    const value = await StorageUtil.getItem('cliente')

    if (value && value.id > 0) {
      if (getConfigEmpresa.naoSolicitarDadosCompletosPWA) {
        await buscarClienteSoTelefone(value.telefone)
      } else if (!value.senha) {
        return
      } else {
        await buscarClienteSenha(value.telefone, value.senha, value.loginAdmin)
      }
    }
  }

  function onchange(text: String) {
    if (numeroInternacional) {
      setTelefone(text)
      return
    }

    text = text.replace(/\D/g, '')

    let newCleaned = text.replace(/\D/g, '').substring(0, 11) // remove non-digit and limit
    if (newCleaned !== cleaned) {
      setCleaned(newCleaned)

      let formatted = newCleaned
      if (newCleaned.length >= 2) {
        formatted = `(${newCleaned.substring(0, 2)}) ${newCleaned.substring(2)}`
      }
      if (newCleaned.length >= 7) {
        formatted = `(${newCleaned.substring(0, 2)}) ${newCleaned.substring(
          2,
          7
        )}-${newCleaned.substring(7)}`
      }

      setTelefone(formatted)
    } else {
      setTelefone(text)
    }
  }

  function onchangeDtNascimento(text: String) {
    text = text.replace(/\D/g, '')

    let newCleaned = text.replace(/\D/g, '').substring(0, 8) // remove non-digit and limit
    if (newCleaned !== cleaned) {
      setCleaned(newCleaned)

      let formatted = newCleaned
      if (newCleaned.length >= 2) {
        formatted = `${newCleaned.substring(0, 2)}/${newCleaned.substring(2)}`
      }
      if (newCleaned.length >= 4) {
        formatted = `${newCleaned.substring(0, 2)}/${newCleaned.substring(
          2,
          4
        )}/${newCleaned.substring(4)}`
      }

      setDataNascimento(formatted)
    } else {
      setDataNascimento(text)
    }
  }

  function proximaPagina(idCliente: number) {
    navigation.navigate('InicioStack', {
      screen: 'Menu',
      params: {
        idCliente: idCliente
      }
    })
  }

  async function buscarClienteSenha(
    telefone_?: string,
    senha_?: any,
    loginAdmin?: boolean
  ) {
    const telefone_limpo = (telefone_ ? telefone_ : telefone).replace(/\D/g, '')

    if (!isTelefoneValido(telefone_limpo)) {
      abrirModal('Informe um telefone válido')
      return
    }

    exibirLoader()

    // depois melhorar isso aqui, se o loginAdmin for true, solicitar o login do admin, deverá na tela anterior salvar o login do admin tbm.
    const cliente = await Api.buscar_cliente(
      telefone_ ? telefone_ : telefone,
      senha_ ? senha_ : senha,
      loginAdmin ? loginAdmin : false
    )

    if (!cliente.status) {
      fecharLoader()
      abrirModal(
        cliente.error_details
          ? cliente.error_details.message
          : 'Erro ao buscar cliente'
      )
      return
    }

    if (cliente.data == '') {
      setTipoOperacao(1)
      fecharLoader()
      return
    }

    const dados_cliente = cliente.data

    if (dados_cliente.alterarSenha) {
      await StorageUtil.removeItem('cliente')

      setTipoOperacao(4)
      fecharLoader()
      setCliente(dados_cliente)
      setTelefone(dados_cliente.telefone)
      abrirModal('Informe uma nova senha')
      return
    }

    dados_cliente.senha = senha_ ? senha_ : senha

    await StorageUtil.setItem('cliente', dados_cliente)

    if (route.params?.retornaLogin) {
      window.location.href = 'http://pwa.localhost:19006/'
      return
    }

    fecharLoader()

    if (route.params && route.params?.forcaLogin) {
      navigation.dispatch(
        CommonActions.reset({
          index: 0,
          routes: [{ name: 'TabNavigator', params: { screen: 'Inicio' } }]
        })
      )

      return
    }

    proximaPagina(dados_cliente.id)
  }

  async function alterarSenha() {
    if (senha != confirmaSenha) {
      abrirModal('As senhas não conferem')
      return
    }
    exibirLoader()

    const resultadoAlteracao = await Api.alterar_senha(cliente.id, senha)

    if (!resultadoAlteracao.status) {
      fecharLoader()
      abrirModal(
        resultadoAlteracao.error_details.message || 'Erro ao alterar senha'
      )
      return
    }

    const { telefone } = resultadoAlteracao.data

    await buscarClienteSenha(telefone, senha)
  }

  async function buscarClienteSoTelefone(
    telefone_?: String,
    dadosCorretos?: boolean
  ) {
    if (!telefone_) {
      abrirModal('Informe um telefone válido')
      return
    }

    const telefone_limpo = telefone_.replace(/\D/g, '')

    if (!isTelefoneValido(telefone_limpo)) {
      abrirModal('Informe um telefone válido')
      return
    }

    const cliente = await Api.buscar_cliente(telefone_)

    if (!cliente.status) {
      fecharLoader()
      abrirModal('Erro ao buscar cliente')
      return
    }

    if (cliente.data == '') {
      // se não existe o cliente mais então manda logar normal
      setTipoOperacao(1)
      return
    }
    await StorageUtil.setItem('cliente', cliente.data)
    proximaPagina(cliente.data.id)
    fecharLoader()
  }

  function isTelefoneValido(telefone: String) {
    if (numeroInternacional) {
      return true
    }

    return telefone.length >= 11
  }

  function isNomeValido(nome: String) {
    return nome.length >= 4 && nome.indexOf(' ') !== -1
  }

  function exibirLoader() {
    // refLoader.current.abrirLoader();
    setLoader(true)
  }
  function fecharLoader() {
    // refLoader.current.fecharLoader();
    setLoader(false)
  }

  async function cadastrarCliente() {
    const telefone_limpo = telefone.replace(/\D/g, '')

    if (!isTelefoneValido(telefone_limpo)) {
      abrirModal('Informe um telefone válido')
      return
    }

    if (!isNomeValido(nome)) {
      abrirModal('Informe seu nome completo')
      return
    }

    if (senha != confirmaSenha) {
      abrirModal('As senhas não conferem')
      return
    }

    if (dataNascimento.length < 10) {
      abrirModal('Informe uma data de nascimento válida')
      return
    }

    const dataNascimentoSplit = dataNascimento.split('/')
    const dia = parseInt(dataNascimentoSplit[0])
    const mes = parseInt(dataNascimentoSplit[1])
    const ano = parseInt(dataNascimentoSplit[2])

    if (dia < 1 || dia > 31) {
      abrirModal('Informe um dia de nascimento válido')
      return
    }

    if (mes < 1 || mes > 12) {
      abrirModal('Informe um mês de nascimento válido')
      return
    }

    if (ano < 1930) {
      abrirModal('Informe um ano de nascimento válido')
      return
    }

    if (senha == '' || confirmaSenha == '') {
      abrirModal('Informe uma senha')
      return
    }

    exibirLoader()
    const resultadoCadastro = await Api.cadastrar_cliente(
      telefone,
      nome,
      getCodEmpresa,
      senha,
      dataNascimento
    )

    if (!resultadoCadastro.status) {
      fecharLoader()
      abrirModal(
        resultadoCadastro.error_details.message || 'Erro ao cadastrar cliente'
      )
      return
    }

    const dados_cliente = resultadoCadastro.data
    dados_cliente.senha = senha

    await StorageUtil.setItem('cliente', dados_cliente)

    fecharLoader()
    proximaPagina(dados_cliente.id)
  }

  async function cadastrarClienteTelefoneNome() {
    const telefone_limpo = telefone.replace(/\D/g, '')

    if (!isTelefoneValido(telefone_limpo)) {
      abrirModal('Informe um telefone válido')
      return
    }

    if (!isNomeValido(nome)) {
      abrirModal('Informe seu nome completo')
      return
    }

    exibirLoader()
    const resultadoCadastro = await Api.cadastrar_cliente(
      telefone,
      nome,
      getCodEmpresa
    )

    if (!resultadoCadastro.status) {
      fecharLoader()
      abrirModal(
        resultadoCadastro.error_details.message || 'Erro ao cadastrar cliente'
      )
      return
    }

    const dados_cliente = resultadoCadastro.data
    await StorageUtil.setItem('cliente', dados_cliente)

    fecharLoader()
    proximaPagina(dados_cliente)
  }

  // Inicio da parte do redefinir senha

  async function enviarCodigo() {
    exibirLoader()
    const telefone_limpo = telefone.replace(/\D/g, '')

    if (!isTelefoneValido(telefone_limpo)) {
      abrirModal('Informe um telefone válido')
      fecharLoader()
      return
    }

    const resultadoRedefinicaoSenha = await Api.solicitarAlterarSenha(
      telefone,
      getCodEmpresa
    )

    if (!resultadoRedefinicaoSenha.status) {
      abrirModal(
        resultadoRedefinicaoSenha.error_details.message ||
          'Erro ao solicitar alteração de senha'
      )
      fecharLoader()
      return
    }
    fecharLoader()
    setTipoOperacaoRedSenha(2)
  }

  async function validarCodigo() {
    exibirLoader()

    const codigo_limpo = codigoRedenficao.replace(/\D/g, '')

    if (!codigo_limpo || codigo_limpo.length < 4) {
      abrirModal('Código inválido')
      fecharLoader()
      return
    }

    const resultadoRedefinicaoSenha = await Api.validarCodigo(
      codigo_limpo,
      telefone
    )

    if (!resultadoRedefinicaoSenha.status) {
      abrirModal(
        resultadoRedefinicaoSenha.error_details.message ||
          'Erro ao solicitar alteração de senha'
      )
      fecharLoader()
      return
    }
    fecharLoader()
    setTipoOperacaoRedSenha(0)
    entrar()
  }

  //fim da parte do redefinir senha

  async function entrar() {
    const telefone_limpo = telefone.replace(/\D/g, '')

    if (!isTelefoneValido(telefone_limpo)) {
      abrirModal('Informe um telefone válido')
      return
    }

    if (tipoOperacao == 2) {
      // cadastrar cliente
      cadastrarCliente()
      return
    }
    if (tipoOperacao == 7 && !cliente.id) {
      // cadastrar cliente só com telefone e nome
      cadastrarClienteTelefoneNome()
      return
    }

    if (tipoOperacao == 3) {
      // login normal com senha
      buscarClienteSenha()
      return
    }
    if (tipoOperacao == 4) {
      // alterar senha
      alterarSenha()
      return
    }

    exibirLoader()

    const clienteRet = await Api.buscar_cliente(telefone)
    if (!clienteRet.status) {
      fecharLoader()
      abrirModal('Erro ao buscar cliente')
      return
    }
    if (getConfigEmpresa.naoSolicitarDadosCompletosPWA) {
      if (clienteRet.data != '') {
        await buscarClienteSoTelefone(clienteRet.data.telefone)
      }
      setTipoOperacao(7)
    } else if (clienteRet.data == '') {
      setTipoOperacao(2)
    } else if (clienteRet.data.alterarSenha) {
      setTipoOperacao(4)
      abrirModal('Informe uma nova senha')
    } else if (clienteRet.data.id > 0) {
      setTipoOperacao(3)
    }

    setCliente(clienteRet.data)
    fecharLoader()
  }

  function abrirModal(texto: String) {
    if (refModal.current) {
      setTextoModal(texto)
      refModal.current.abrirModal(texto)
    }
  }

  function renderConfirmarCodigoComponente() {
    return (
      <Box
        style={[styles.container, { alignItems: 'center', paddingHorizontal: 20 }]}
      >
        <Box
          style={{
            width: wp('25%'),
            height: wp('25%'),
            borderRadius: wp('12.5%'),
            backgroundColor: primaryColor ?? '#1976d2',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 20,
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 4 },
            shadowOpacity: 0.3,
            shadowRadius: 8,
            elevation: 8
          }}
        >
          <FontAwesome name="lock" size={wp('12%')} color="#fff" />
        </Box>

        <Text 
          style={[styles.corFonteSubtitulos, { fontWeight: 'bold', marginBottom: 8 }]} 
          fontSize={'2xl'}
        >
          Código de Verificação
        </Text>

        <Text 
          style={[styles.textPadrao, { textAlign: 'center', marginBottom: 30, opacity: 0.8 }]} 
          fontSize={'md'}
        >
          Digite o código de 4 dígitos que enviamos via WhatsApp para o número abaixo
        </Text>

        <Box
          style={{
            width: wp('90%'),
            alignItems: 'center'
          }}
        >
          <Box
            style={{
              width: '100%',
              backgroundColor: 'rgba(128, 128, 128, 0.1)',
              borderRadius: 12,
              padding: 15,
              marginBottom: 25,
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <FontAwesome name="whatsapp" size={24} color="#25D366" style={{ marginRight: 10 }} />
            <Text style={[styles.textPadrao, { fontSize: 18, fontWeight: '600' }]}>
              {telefone}
            </Text>
          </Box>

          <Input
            icon={'app-registration'}
            colorItem={getConfigEmpresa.coresPWA.corFonteFiltro}
            corBordaFiltro={getConfigEmpresa.coresPWA.corBordaFiltro}
            value={codigoRedenficao as any}
            styleBox={{ marginBottom: 10 }}
            onChangeText={(text: any) => {
              setCodigoRedenficao(text)
            }}
            type='number'
            width={'100%'}
            placeholder='Digite o código de 4 dígitos'
            helperText='Código de verificação'
          />

          <Button
            style={[
              styles.button,
              {
                backgroundColor: primaryColor ?? '#1976d2',
                marginTop: 15,
                borderRadius: 12,
                shadowColor: primaryColor ?? '#1976d2',
                shadowOffset: { width: 0, height: 4 },
                shadowOpacity: 0.4,
                shadowRadius: 8,
                elevation: 6
              }
            ]}
            isDisabled={codigoRedenficao.length != 4}
            onPress={async () => {
              validarCodigo()
            }}
          >
            <Text style={[styles.buttonText, { fontWeight: 'bold', fontSize: 16 }]}>
              VALIDAR CÓDIGO{' '}
              <FontAwesome name="check-circle" size={18} color="#fff" />
            </Text>
          </Button>

          <Pressable
            onPress={() => {
              setTipoOperacaoRedSenha(1)
            }}
            style={{ marginTop: 20 }}
          >
            <Text style={[styles.textCadastro, { fontSize: 15 }]}>
              <FontAwesome name="refresh" size={14} /> Não recebeu o código? Reenviar
            </Text>
          </Pressable>
        </Box>
      </Box>
    )
  }

  function renderEsqueceuSenhaComponente() {
    return (
      <Box
        style={[styles.container, { alignItems: 'center', paddingHorizontal: 20 }]}
      >
        <Box
          style={{
            width: wp('25%'),
            height: wp('25%'),
            borderRadius: wp('12.5%'),
            backgroundColor: primaryColor ?? '#1976d2',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 20,
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 4 },
            shadowOpacity: 0.3,
            shadowRadius: 8,
            elevation: 8
          }}
        >
          <FontAwesome name="key" size={wp('12%')} color="#fff" />
        </Box>

        {/* Title */}
        <Text 
          style={[styles.corFonteSubtitulos, { fontWeight: 'bold', marginBottom: 8 }]} 
          fontSize={'2xl'}
        >
          Recuperar Senha
        </Text>

        <Text 
          fontSize={'md'} 
          style={[styles.textPadrao, { textAlign: 'center', marginBottom: 10, opacity: 0.8 }]}
        >
          Não se preocupe! Vamos te ajudar a recuperar sua senha de forma simples e rápida.
        </Text>

        <Box
          style={{
            width: wp('90%'),
            backgroundColor: 'rgba(25, 118, 210, 0.1)',
            borderLeftWidth: 4,
            borderLeftColor: primaryColor ?? '#1976d2',
            borderRadius: 8,
            padding: 15,
            marginBottom: 30,
            marginTop: 10
          }}
        >
          <Text style={[styles.textPadrao, { fontSize: 14, lineHeight: 20 }]}>
            <FontAwesome name="info-circle" size={16} color={primaryColor ?? '#1976d2'} />
            {' '}Enviaremos um código de verificação via WhatsApp para o número cadastrado.
          </Text>
        </Box>

        <Box
          style={{
            width: wp('90%'),
            alignItems: 'center'
          }}
        >
          <Input
            icon={'call'}
            colorItem={getConfigEmpresa.coresPWA.corFonteFiltro}
            corBordaFiltro={getConfigEmpresa.coresPWA.corBordaFiltro}
            value={telefone as any}
            onChangeText={(text: any) => {
              if (text.length > 15) {
                return
              }
              onchange(text)
            }}
            width={'100%'}
            placeholder='(00) 00000-0000'
            helperText='Digite seu número de telefone'
          />

          <Button
            style={[
              styles.button,
              {
                backgroundColor: primaryColor ?? '#1976d2',
                marginTop: 25,
                borderRadius: 12,
                shadowColor: primaryColor ?? '#1976d2',
                shadowOffset: { width: 0, height: 4 },
                shadowOpacity: 0.4,
                shadowRadius: 8,
                elevation: 6
              }
            ]}
            isDisabled={telefone.length < 15}
            onPress={async () => {
              enviarCodigo()
            }}
          >
            <Text style={[styles.buttonText, { fontWeight: 'bold', fontSize: 16 }]}>
              ENVIAR CÓDIGO{' '}
              <FontAwesome name="paper-plane" size={16} color="#fff" />
            </Text>
          </Button>

          <Pressable
            onPress={() => {
              setTipoOperacaoRedSenha(0)
            }}
            style={{ marginTop: 20 }}
          >
            <Text style={[styles.textCadastro, { fontSize: 15 }]}>
              <FontAwesome name="arrow-left" size={14} /> Voltar para o login
            </Text>
          </Pressable>
        </Box>
      </Box>
    )
  }

  function confirmarNacionalidadeNumero() {
    confirmationRef.current.fecharModal()
    setNumeroInternacional(!numeroInternacional)

    if (!numeroInternacional) {
      abrirModal('Informe apenas os números do seu telefone')
    }

    setTelefone('')
  }

  function renderPrincipal() {
    return (
      <Box style={[styles.container, { backgroundColor: backgroundColor }]}>
        <Box
          style={[
            styles.imageContainer,
            {
              borderColor: primaryColor ?? 'defaultColor',
              backgroundColor: 'rgba(204, 204, 204, 0.1)'
            }
          ]}
        >
          <Image
            alt='Login'
            source={{
              uri: getConfigEmpresa.logo || logo
            }}
            style={styles.image}
          />
        </Box>

        <Text style={[styles.headerText]}>
          {getConfigEmpresa.nomeFantasia ?? 'Agenda Simplificada'}
        </Text>

        <Box
          style={{
            width: wp('80%'),
            marginTop: 10,
            alignItems: 'flex-end'
          }}
        >
          {getConfigEmpresa.removerValidacaoTelefone && (
            <TouchableOpacity
              onPress={() => {
                confirmationRef.current.abrirModal()
              }}
            >
              <Text fontSize={'md'} style={styles.textFoneInternacional}>
                Número {numeroInternacional ? 'Nacional' : 'Internacional'} ?
              </Text>
            </TouchableOpacity>
          )}

          <Input
            icon={'call'}
            colorItem={getConfigEmpresa.coresPWA.corFonteFiltro}
            corBordaFiltro={getConfigEmpresa.coresPWA.corBordaFiltro}
            value={telefone as any}
            onChangeText={(text: any) => {
              if (text.length > 15) {
                return
              }

              onchange(text)
            }}
            width={'100%'}
            placeholder='Telefone'
            helperText='Informe o seu telefone'
          />
          {!cliente.id && (tipoOperacao == 2 || tipoOperacao == 7) && (
            <Input
              value={nome as any}
              colorItem={getConfigEmpresa.coresPWA.corFonteFiltro}
              corBordaFiltro={getConfigEmpresa.coresPWA.corBordaFiltro}
              styleBox={{ marginTop: 5 }}
              icon={'call'}
              onChangeText={(text: any) => {
                setNome(text)
              }}
              width={'100%'}
              placeholder='Nome Completo'
              helperText='Informe o seu nome completo'
            />
          )}

          {!cliente.id && tipoOperacao == 2 && (
            <Input
              value={dataNascimento as any}
              colorItem={getConfigEmpresa.coresPWA.corFonteFiltro}
              corBordaFiltro={getConfigEmpresa.coresPWA.corBordaFiltro}
              styleBox={{ marginTop: 5 }}
              icon={'calendar-today'}
              type='number'
              onChangeText={(text) => {
                if (text.length > 10) {
                  return
                }
                onchangeDtNascimento(text)
              }}
              width={'100%'}
              placeholder='EX: DD/MM/AAAA'
              helperText='Informe a sua data de nascimento'
            />
          )}

          {((!cliente.id && tipoOperacao == 2) ||
            tipoOperacao == 3 ||
            tipoOperacao == 4) && (
            <Input
              value={senha as any}
              colorItem={getConfigEmpresa.coresPWA.corFonteFiltro}
              corBordaFiltro={getConfigEmpresa.coresPWA.corBordaFiltro}
              styleBox={{ marginTop: 5 }}
              icon={'vpn-key'}
              type={'password'}
              // style={{marginTop:10}}
              onChangeText={(text: any) => {
                setSenha(text)
              }}
              width={'100%'}
              placeholder='Senha'
              helperText='Informe a sua senha'
            />
          )}
          {((!cliente.id && tipoOperacao == 2) || tipoOperacao == 4) && (
            <Input
              value={confirmaSenha as any}
              styleBox={{ marginTop: 5 }}
              icon={'vpn-key'}
              colorItem={getConfigEmpresa.coresPWA.corFonteFiltro}
              corBordaFiltro={getConfigEmpresa.coresPWA.corBordaFiltro}
              type={'password'}
              // style={{marginTop:10}}
              onChangeText={(text: any) => {
                setConfirmaSenha(text)
              }}
              width={'100%'}
              placeholder='Confirma Senha'
              helperText='Confirme a sua senha'
            />
          )}

          <Button
            style={[
              styles.button,
              { backgroundColor: primaryColor ?? 'defaultColor' }
            ]}
            onPress={async () => {
              entrar()
            }}
          >
            <Text style={styles.buttonText} fontWeight='bold' fontSize='md'>
              ENTRAR{' '}
              <FontAwesome
                name='sign-in'
                size={18}
                color='#fff'
                style={{ marginLeft: 4 }}
              />
            </Text>
          </Button>

          {!getConfigEmpresa.naoSolicitarDadosCompletosPWA && (
            <Pressable
              onPress={() => {
                setTipoOperacaoRedSenha(1)
              }}
            >
              <Text style={styles.textCadastro} fontSize={'lg'}>
                Esqueceu a senha?
              </Text>
            </Pressable>
          )}
        </Box>
      </Box>
    )
  }

  function renderModais() {
    return (
      <>
        <ModalConfirmacao
          titulo={'Atenção'}
          ref={refModal}
          mensagem={textoModal as any}
          textoBotaoPositivo={'OK'}
          onConfirmPositivo={() => {
            if (refModal.current) {
              refModal.current.fecharModal()
            }
          }}
        />

        {/* ficou invertido as confições pq vai servir tanto para um quanto para outro */}
        <ModalConfirmacao
          ref={confirmationRef}
          titulo={'Atenção'}
          mensagem={`O seu número de telefone é ${
            numeroInternacional ? 'Nacional' : 'Internacional'
          } ?`}
          textoBotaoNegativo={'Não'}
          textoBotaoPositivo={'Sim'}
          onConfirmNegativo={() => confirmationRef.current.fecharModal()}
          onConfirmPositivo={() => confirmarNacionalidadeNumero()}
        />
      </>
    )
  }

  // ---------------- Layout novo ----------------
  // O modo legado (pwa simples / layout v2 / tema escuro) continua com o layout antigo
  const utilizaLayoutLegado =
    getConfigEmpresa.utilizaPwaSimples ||
    getConfigEmpresa.versaoPWA == 2 ||
    getConfigEmpresa.utilizaTemaEscuro

  const corPrincipal: string = primaryColor || '#006400'
  const corTextoPrincipal = corTextoSobre(corPrincipal)

  function onChangeTelefone(text: string) {
    if (text.length > 15) {
      return
    }
    onchange(text)
  }

  function campoTelefone(ajuda?: string) {
    return (
      <Campo
        rotulo={numeroInternacional ? 'Seu telefone' : 'Seu WhatsApp'}
        valor={String(telefone || '')}
        onChangeText={onChangeTelefone}
        corPrincipal={corPrincipal}
        prefixo={numeroInternacional ? undefined : '+55'}
        icone='phone'
        placeholder={
          numeroInternacional ? 'Somente números' : '(00) 00000-0000'
        }
        ajuda={ajuda}
        numerico
        destaque
      />
    )
  }

  function botaoPrincipal(
    texto: string,
    icone: string,
    onPress: () => void,
    desabilitado = false
  ) {
    return (
      <TouchableOpacity
        activeOpacity={0.85}
        disabled={desabilitado}
        onPress={onPress}
        style={[
          stylesNovo.botao,
          { backgroundColor: corPrincipal, opacity: desabilitado ? 0.45 : 1 }
        ]}
      >
        <RNText style={[stylesNovo.textoBotao, { color: corTextoPrincipal }]}>
          {texto}
        </RNText>
        <Feather name={icone as any} size={18} color={corTextoPrincipal} />
      </TouchableOpacity>
    )
  }

  function link(texto: string, onPress: () => void, icone?: string) {
    return (
      <TouchableOpacity style={stylesNovo.link} onPress={onPress}>
        {!!icone && <Feather name={icone as any} size={14} color={corPrincipal} />}
        <RNText style={[stylesNovo.textoLink, { color: corPrincipal }]}>
          {texto}
        </RNText>
      </TouchableOpacity>
    )
  }

  function renderCardLogin() {
    return (
      <>
        {campoTelefone('Use o mesmo número dos seus agendamentos.')}

        {getConfigEmpresa.removerValidacaoTelefone &&
          link(
            `Meu número é ${numeroInternacional ? 'nacional' : 'internacional'}`,
            () => confirmationRef.current.abrirModal()
          )}

        {!cliente.id && (tipoOperacao == 2 || tipoOperacao == 7) && (
          <Campo
            rotulo='Nome completo'
            valor={String(nome || '')}
            onChangeText={(text) => setNome(text)}
            corPrincipal={corPrincipal}
            icone='user'
            placeholder='Seu nome e sobrenome'
          />
        )}

        {!cliente.id && tipoOperacao == 2 && (
          <Campo
            rotulo='Data de nascimento'
            valor={String(dataNascimento || '')}
            onChangeText={(text) => {
              if (text.length > 10) {
                return
              }
              onchangeDtNascimento(text)
            }}
            corPrincipal={corPrincipal}
            icone='calendar'
            placeholder='DD/MM/AAAA'
            numerico
          />
        )}

        {((!cliente.id && tipoOperacao == 2) ||
          tipoOperacao == 3 ||
          tipoOperacao == 4) && (
          <Campo
            rotulo={tipoOperacao == 4 ? 'Nova senha' : 'Senha'}
            valor={String(senha || '')}
            onChangeText={(text) => setSenha(text)}
            corPrincipal={corPrincipal}
            icone='lock'
            placeholder='Sua senha'
            senha
          />
        )}

        {((!cliente.id && tipoOperacao == 2) || tipoOperacao == 4) && (
          <Campo
            rotulo='Confirme a senha'
            valor={String(confirmaSenha || '')}
            onChangeText={(text) => setConfirmaSenha(text)}
            corPrincipal={corPrincipal}
            icone='lock'
            placeholder='Repita a senha'
            senha
          />
        )}

        {botaoPrincipal('Entrar', 'arrow-right', () => entrar())}

        {!getConfigEmpresa.naoSolicitarDadosCompletosPWA && (
          <View style={{ alignItems: 'center', marginTop: 6 }}>
            {link('Esqueceu a senha?', () => setTipoOperacaoRedSenha(1))}
          </View>
        )}
      </>
    )
  }

  function renderCardEsqueceuSenha() {
    return (
      <>
        <View
          style={[
            stylesNovo.aviso,
            { backgroundColor: corComAlpha(corPrincipal, 0.08) }
          ]}
        >
          <Feather name='message-circle' size={16} color={corPrincipal} />
          <RNText style={stylesNovo.textoAviso}>
            Vamos enviar um código de verificação pelo WhatsApp para o número
            cadastrado.
          </RNText>
        </View>

        {campoTelefone()}

        {botaoPrincipal(
          'Enviar código',
          'send',
          () => enviarCodigo(),
          telefone.length < 15
        )}

        <View style={{ alignItems: 'center', marginTop: 6 }}>
          {link(
            'Voltar para o login',
            () => setTipoOperacaoRedSenha(0),
            'arrow-left'
          )}
        </View>
      </>
    )
  }

  function renderCardCodigo() {
    return (
      <>
        <View style={stylesNovo.telefoneEnviado}>
          <FontAwesome name='whatsapp' size={20} color='#25D366' />
          <RNText style={stylesNovo.textoTelefoneEnviado}>{telefone}</RNText>
        </View>

        <Campo
          rotulo='Código de verificação'
          valor={String(codigoRedenficao || '')}
          onChangeText={(text) => setCodigoRedenficao(text)}
          corPrincipal={corPrincipal}
          icone='hash'
          placeholder='0000'
          numerico
          maxLength={4}
          destaque
          estiloInput={stylesNovo.inputCodigo}
        />

        {botaoPrincipal(
          'Validar código',
          'check',
          () => validarCodigo(),
          codigoRedenficao.length != 4
        )}

        <View style={{ alignItems: 'center', marginTop: 6 }}>
          {link(
            'Não recebeu o código? Reenviar',
            () => setTipoOperacaoRedSenha(1),
            'refresh-cw'
          )}
        </View>
      </>
    )
  }

  if (!utilizaLayoutLegado) {
    const textos =
      tipoOperacaoRedSenha == 1
        ? {
            titulo: 'Recuperar senha',
            subtitulo: 'Não se preocupe, a gente te ajuda\na entrar de novo.'
          }
        : tipoOperacaoRedSenha == 2
        ? {
            titulo: 'Código de verificação',
            subtitulo: 'Digite o código de 4 dígitos que\nenviamos pelo WhatsApp.'
          }
        : {
            titulo: 'Área do cliente',
            subtitulo: 'Seus agendamentos e pacotes\nem um só lugar.'
          }

    return (
      <View style={stylesNovo.container}>
        <ScrollView
          style={{ flex: 1, width: '100%' }}
          contentContainerStyle={{ alignItems: 'center', paddingBottom: 100 }}
        >
          <div
            style={{
              position: 'relative',
              overflow: 'hidden',
              width: '100%',
              boxSizing: 'border-box',
              paddingTop: 40,
              paddingBottom: 90,
              paddingLeft: 20,
              paddingRight: 20,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              backgroundColor: corPrincipal,
              backgroundImage: gradienteHero(corPrincipal),
              borderBottomLeftRadius: 8,
              borderBottomRightRadius: 8
            }}
          >
            <div style={circuloDecorativo(220, -70, -70)} />
            <div style={circuloDecorativo(140, -30, -30)} />

            <View style={stylesNovo.anelLogo}>
              <View style={stylesNovo.circuloLogo}>
                <RNImage
                  source={{ uri: getConfigEmpresa.logo || logo }}
                  style={{ width: '86%', height: '86%' }}
                  resizeMode='contain'
                />
              </View>
            </View>

            {!!getConfigEmpresa.nomeFantasia && (
              <RNText style={stylesNovo.nomeEmpresa}>
                {String(getConfigEmpresa.nomeFantasia).toUpperCase()}
              </RNText>
            )}

            <RNText style={[stylesNovo.titulo, { color: corTextoPrincipal }]}>
              {textos.titulo}
            </RNText>
            <RNText style={[stylesNovo.subtitulo, { color: corTextoPrincipal }]}>
              {textos.subtitulo}
            </RNText>
          </div>

          <View style={stylesNovo.largura}>
            <View style={[stylesNovo.card, sombraCard]}>
              {tipoOperacaoRedSenha == 0
                ? renderCardLogin()
                : tipoOperacaoRedSenha == 1
                ? renderCardEsqueceuSenha()
                : renderCardCodigo()}
            </View>
          </View>
        </ScrollView>

        {loader && <Loader ref={refLoader} />}
        {renderModais()}
      </View>
    )
  }

  // ---------------- Layout legado ----------------
  return (
    <Box
      style={{
        backgroundColor: backgroundColor
      }}
    >
      {tipoOperacaoRedSenha == 0
        ? renderPrincipal()
        : tipoOperacaoRedSenha == 1
        ? renderEsqueceuSenhaComponente()
        : renderConfirmarCodigoComponente()}
      <Box style={styles.footer}></Box>

      {loader && <Loader ref={refLoader} />}

      {renderModais()}
    </Box>
  )
}

const DOURADO = '#E3BF7A'

function circuloDecorativo(
  tamanho: number,
  top: number,
  right: number
): React.CSSProperties {
  return {
    position: 'absolute',
    width: tamanho,
    height: tamanho,
    top,
    right,
    borderRadius: '50%',
    border: '1px solid rgba(255,255,255,0.12)',
    pointerEvents: 'none'
  }
}

const stylesNovo = StyleSheet.create({
  container: {
    flex: 1,
    width: '100%',
    minHeight: '100%',
    alignItems: 'center',
    backgroundColor: CORES.fundo
  },
  largura: {
    width: '100%',
    maxWidth: 560,
    paddingHorizontal: 16
  },
  anelLogo: {
    width: 112,
    height: 112,
    borderRadius: 56,
    padding: 6,
    backgroundColor: 'rgba(255,255,255,0.12)',
    marginBottom: 16
  },
  circuloLogo: {
    flex: 1,
    borderRadius: 50,
    backgroundColor: '#fff',
    overflow: 'hidden',
    alignItems: 'center',
    justifyContent: 'center'
  },
  nomeEmpresa: {
    color: DOURADO,
    fontSize: 12,
    fontWeight: '700',
    letterSpacing: 3,
    textAlign: 'center',
    marginBottom: 6
  },
  titulo: {
    fontSize: 28,
    fontWeight: '800',
    textAlign: 'center'
  },
  subtitulo: {
    fontSize: 14,
    opacity: 0.85,
    textAlign: 'center',
    marginTop: 6
  },
  card: {
    marginTop: -56,
    padding: 18,
    borderRadius: 22,
    backgroundColor: CORES.card,
    borderWidth: 1,
    borderColor: CORES.borda
  },
  botao: {
    height: 52,
    borderRadius: 14,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    marginTop: 6
  },
  textoBotao: {
    fontSize: 16,
    fontWeight: '700'
  },
  link: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    alignSelf: 'flex-start',
    paddingVertical: 8
  },
  textoLink: {
    fontSize: 14,
    fontWeight: '700'
  },
  aviso: {
    flexDirection: 'row',
    gap: 10,
    padding: 12,
    borderRadius: 12,
    marginBottom: 16
  },
  textoAviso: {
    flex: 1,
    fontSize: 13,
    lineHeight: 18,
    color: CORES.titulo
  },
  telefoneEnviado: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    padding: 12,
    borderRadius: 12,
    backgroundColor: '#F7F4EE',
    marginBottom: 16
  },
  textoTelefoneEnviado: {
    fontSize: 16,
    fontWeight: '700',
    color: CORES.titulo
  },
  inputCodigo: {
    fontSize: 22,
    fontWeight: '800',
    letterSpacing: 8
  }
})

export default Login
